export default __webpack_public_path__ + "static/media/oficina.a4616833.svg";